module.exports = __webpack_public_path__ + "img/logo_github_black.cefc2023.png";